// Staff sign-in and allowlist: the routes of `core.host.staff-auth` (ADR-0027).
// A core feature is on in each deployment.
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'core.host.staff-auth',
    routes: [
        { frontend: 'public', path: 'login', lazy: () => import('@/pages/login/page') },
        {
            frontend: 'public',
            path: 'not-authorised',
            lazy: () => import('@/pages/not-authorised/page'),
        },
    ],
});
